module.exports = __webpack_public_path__ + "img/8.2065a732.png";